interface MachineAppImplementationDefinition {
  name: string;
  type: string;
  uuid: string;
  isAvailable: boolean;
  repositoryName: string;
  modulePath: string[];
}

// TODO: Temporary MachineApp payload
const machineAppList: MachineAppImplementationDefinition[] = [
  {
    name: 'Cartesian Palletizer',
    type: 'cartesian_palletizer',
    uuid: '1',
    isAvailable: false,
    repositoryName: '@ventionco/machine-app-components',
    modulePath: ['default', 'CartesianPalletizer'],
  },
  {
    name: 'Cobot Palletizer',
    type: 'cobot_palletizer',
    uuid: '2',
    isAvailable: false, //HACK for PATH-FOLLOWING-VENTION-IO.
    repositoryName: '@ventionco/machine-app-components',
    modulePath: ['default', 'CobotPalletizer'],
  },
  {
    name: 'Path Following',
    type: 'path_following',
    uuid: '3',
    isAvailable: true,
    repositoryName: '@ventionco/machine-app-components',
    modulePath: ['default', 'PathFollowing'],
  },
  {
    name: 'Example App',
    type: 'example_app',
    uuid: '4',
    isAvailable: false,
    repositoryName: '@ventionco/machine-app-components',
    modulePath: ['default', 'Example'],
  }
];

export function getMachineAppList(): MachineAppImplementationDefinition[] {
  const developerDataJsonStr = localStorage.getItem('machine_app_implementation_data');
  const developerLoadedData = developerDataJsonStr ? JSON.parse(developerDataJsonStr) : {};
  return machineAppList.map(item => ({
    ...item,
    isAvailable: (developerLoadedData && developerLoadedData[item.type]) || item.isAvailable
  }));
}

function updateDeveloperLocalStorage(item: MachineAppImplementationDefinition) {
  const developerDataJsonStr = localStorage.getItem('machine_app_implementation_data');
  const developerLoadedData = developerDataJsonStr ? JSON.parse(developerDataJsonStr) : {};
  developerLoadedData[item.type] = item.isAvailable;
  localStorage.setItem('machine_app_implementation_data', JSON.stringify(developerLoadedData));
}

export function enableMachineApp(uuid: string) {
  const item = machineAppList.find(item => item.uuid === uuid);
  if (!item) {
    console.error(`Failed to find item with uuid=${uuid}`);
    return;
  }

  item.isAvailable = true;
  updateDeveloperLocalStorage(item);
}

export function disableMachineApp(uuid: string) {
  const item = machineAppList.find(item => item.uuid === uuid);
  if (!item) {
    console.error(`Failed to find item with uuid=${uuid}`);
    return;
  }

  item.isAvailable = false;
  updateDeveloperLocalStorage(item);
}